module.exports = __webpack_public_path__ + "img/DSC_0342_1.2fb786bb.jpg";